import { ShieldCheck, Wrench, Brain, Target } from "lucide-react";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";

const points = [
  {
    icon: ShieldCheck,
    title: "Reliable & Responsive",
    desc: "Fast turnaround times and proactive monitoring so issues get resolved before they escalate.",
  },
  {
    icon: Wrench,
    title: "Custom-Built Solutions",
    desc: "No cookie-cutter templates. Every system is engineered to fit your specific business needs.",
  },
  {
    icon: Brain,
    title: "Deep Technical Expertise",
    desc: "Full-stack engineering skills across software, hardware, networking, and automation.",
  },
  {
    icon: Target,
    title: "Business-Focused Approach",
    desc: "Technology decisions driven by your goals — not by the latest trends or buzzwords.",
  },
];

const WhyChooseUs = () => {
  const headingRef = useScrollReveal();
  const gridRef = useStaggerReveal(100);

  return (
    <section id="why-us" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-6">
        <div ref={headingRef} className="mx-auto max-w-2xl text-center" data-reveal>
          <h2
            className="text-3xl font-bold tracking-tight text-foreground md:text-4xl"
            style={{ textWrap: "balance" }}
          >
            Why Work With Us
          </h2>
          <p className="mt-4 text-muted-foreground" style={{ textWrap: "pretty" }}>
            We combine deep technical knowledge with a straightforward, business-first mindset.
          </p>
        </div>

        <div ref={gridRef} className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {points.map((p) => (
            <div
              key={p.title}
              data-reveal
              className="flex flex-col items-start"
            >
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-primary/5 text-primary">
                <p.icon className="h-5 w-5" />
              </div>
              <h3 className="text-base font-semibold text-foreground">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
